import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .VerificationPanel {
    .WarningMessage {
      padding: 20px !important;
      margin-bottom: 40px;
      text-align: left !important;
      @include respond-to(sm) {
        padding: 10px;
      }
    }
    .WarningMessage__text-inner {
      margin: 0 !important;
    }
  }
  @include respond-to(sm) {
    .VerificationPanel {
      position: relative;
      &.inView::after {
        display: block;
      }
      &.inView2::before {
        display: block;
      }
    }
    .VerificationPanel:before,
    .VerificationPanel:after {
      content: '';
      display: none;
      position: absolute;
      top: -10px;
      left: 0;
      width: 20px;
      height: 45px;
      background: transparent;
      background: linear-gradient(90deg, rgba(34, 34, 34, 0.15) 0%, rgba(34, 34, 34, 0) 100%);
    }
    .VerificationPanel:after {
      background: transparent;
      background: linear-gradient(90deg, rgba(34, 34, 34, 0) 0%, rgba(34, 34, 34, 0.15) 100%);
      left: auto;
      right: 0;
    }
  }

  .VerificationPanel-WarningMessage {
    background-color: rgb(252, 235, 179) !important;
    height: 50px !important;
    padding: 0px 16px !important;
    display: flex !important;
    -webkit-box-align: center !important;
    align-items: center !important;
    -webkit-box-pack: start !important;
    justify-content: flex-start !important;
    box-sizing: border-box !important;
    margin-bottom: 30px !important;
    border-radius: 10px !important;
    width: auto !important;
    display: inline-flex !important;
  }

    .WarningMessage__text-inner> span {
      color: #000 !important;
      font-family: 'Samsung Sharp Sans' !important;
      font-size: 12px !important;
      font-style: normal !important;
      font-weight: 500 !important;
      line-height: normal !important;
      opacity: 1 !important;
      margin-left: 20px !important;
    }
`;

export default staticStyles;
